export const styles = {
  section: {
    pt: { xs: '32px !important', lg: '40px !important' },
    pb: { xs: '24px !important', lg: '80px !important' },
    overflow: 'hidden',
    mt: '-1px',
    ml: '-1px',
  },
  container: {
    width: { xs: '100%', lg: 'calc(100% + 60px)' },
    ml: { xs: 0, lg: -3.75 },
    backgroundColor: 'kit.background.gray',
    borderRadius: { xs: 0, lg: 4 },
    overflow: 'hidden',
    p: { xs: 0, lg: '48px 30px' },
  },
  cardsContainer: {
    mt: 4,
    '& > :not(:first-of-type)': { mt: { xs: 2, lg: 0 } },
  },
  imgGrid: {
    display: { xs: 'none', lg: 'block' },
    pl: 5,
  },
  cardRoot: {
    p: (theme) => theme.spacing(2, 2, 3, 2),
    height: { xs: 'auto', lg: 333 },
  },
  iconBox: { height: { xs: 40, lg: 56 }, width: { xs: 40, lg: 56 }, mb: -1 },
};
